const icoTerminal = "/frontend/web/img/map/cluster-blue.svg";
const icoStore = "/frontend/web/img/map/cluster-orange.svg";

export const getClusterOptions = (type: "terminal" | "store") => ({
    gridSize: 60,
    maxZoom: 15,
    styles: [
        {
            height: 57,
            width: 46,
            textLineHeight: 46,
            textSize: 18,
            textColor: "#ffffff",
            url: type == "terminal" ? icoTerminal : icoStore,
            backgroundPosition: "",
        },
        {
            height: 63,
            width: 49,
            textLineHeight: 49,
            textSize: 18,
            textColor: "#ffffff",
            url: type == "terminal" ? icoTerminal : icoStore,
        },
        {
            height: 69,
            width: 53,
            textLineHeight: 53,
            textSize: 18,
            textColor: "#ffffff",
            url: type == "terminal" ? icoTerminal : icoStore,
        },
        {
            height: 75,
            width: 58,
            textLineHeight: 58,
            textSize: 18,
            textColor: "#ffffff",
            url: type == "terminal" ? icoTerminal : icoStore,
        },
        {
            height: 81,
            width: 63,
            textLineHeight: 63,
            textSize: 18,
            textColor: "#ffffff",
            url: type == "terminal" ? icoTerminal : icoStore,
        },
    ],
});
